/* @flow */
import { em } from 'polished';

export default {
  root: {
    width: em(33),
    height: em(32),
  },
};
